import React from "react";

function EvaluationItem(props){
    return(
        <div>
                <br/><img src={props.image} alt=""  /><br/>
                {props.dateName}<br/>
                {props.eval}<br/><br/>


        </div>

    );
}

export default EvaluationItem